export const messages = {
  en: {
    reportOwnerPayFee: {
      queryCondition: 'Query Conditions',
      selectFeeType: 'Select Fee Type',
      selectFeeItem: 'Select Fee Item',
      inputRoomNum: 'Input Room Number',
      inputOwnerName: 'Input Owner Name',
      inputYear: 'Input Year',
      paymentDetails: 'Owner Payment Details',
      paymentDetailsTip: 'Details of owner payment records',
      owner: 'Owner',
      room: 'Room',
      feeItem: 'Fee Item',
      month: 'Month',
      total: 'Total',
      receivable: 'Receivable',
      prepayment: 'Prepayment',
      fetchError: 'Failed to fetch payment details'
    }
  },
  zh: {
    reportOwnerPayFee: {
      queryCondition: '查询条件',
      selectFeeType: '请选择收费大类',
      selectFeeItem: '请选择收费项',
      inputRoomNum: '请输入房屋编号',
      inputOwnerName: '请输入业主名称',
      inputYear: '请输入年份',
      paymentDetails: '业主缴费明细',
      paymentDetailsTip: '业主缴费记录明细',
      owner: '业主',
      room: '房屋',
      feeItem: '费用项目',
      month: '月',
      total: '合计',
      receivable: '应收',
      prepayment: '预收',
      fetchError: '获取缴费明细失败'
    }
  }
}